export const FETCH_EMPLOYEES_LIST_OPTIONS_SUCCESS = 'FETCH_EMPLOYEES_LIST_OPTIONS_SUCCESS';
export const FETCH_DEPARTMENTS_LIST_OPTIONS_SUCCESS = 'FETCH_DEPARTMENTS_LIST_OPTIONS_SUCCESS';
export const FETCH_BUSINESS_UNITS_LIST_SUCCESS = 'FETCH_BUSINESS_UNITS_LIST_SUCCESS';
export const FETCH_ROLES_LIST_OPTIONS_SUCCESS = 'FETCH_ROLES_LIST_OPTIONS_SUCCESS';
export const UPDATE_REQUESTS_FILTERS = 'UPDATE_REQUESTS_FILTERS';